import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import ThreadList from "../components/messaging/ThreadList";
import ChatThread from "../components/messaging/ChatThread";

const MessagesRoute = () => {
  const { contactRequestId } = useParams();
  const navigate = useNavigate();
  const { userRole } = useAuth();
  const [selectedThread, setSelectedThread] = useState(null);

  const activeId = contactRequestId || selectedThread?.contact_request_id;
  const activeThread = selectedThread;
  const base = userRole === "athlete" ? "/athlete/messages" : "/scout/messages";

  const handleSelectThread = (thread) => {
    setSelectedThread(thread);
    navigate(`${base}/${thread.contact_request_id}`);
  };

  const handleBack = () => {
    setSelectedThread(null);
    navigate(base);
  };

  return (
    <main className="flex-1 overflow-hidden bg-gray-50">
      <div className="flex h-full flex-col lg:flex-row">
        {/* Thread list — hidden on mobile when a thread is open */}
        <div
          className={`w-full border-r border-gray-200 bg-white lg:block lg:w-80 xl:w-96 ${
            activeId ? "hidden" : "block"
          }`}
        >
          <div className="border-b border-gray-200 px-4 py-4">
            <h1 className="text-lg font-bold text-gray-900">Mensajes</h1>
          </div>
          <div className="overflow-y-auto" style={{ height: "calc(100% - 57px)" }}>
            <ThreadList onSelectThread={handleSelectThread} selectedId={activeId} />
          </div>
        </div>

        {/* Chat thread — full screen on mobile, right panel on desktop */}
        <div
          className={`min-w-0 flex-1 bg-white lg:block ${
            activeId ? "block" : "hidden"
          }`}
        >
          {activeId ? (
            <ChatThread
              contactRequestId={activeId}
              thread={activeThread}
              onBack={handleBack}
            />
          ) : (
            <div className="flex h-full flex-col items-center justify-center text-center">
              <MessageSquare size={48} className="mb-3 text-gray-300" />
              <p className="font-medium text-gray-500">
                Selecciona una conversación
              </p>
              <p className="mt-1 text-sm text-gray-400">
                Elige una conversación de la lista para ver los mensajes.
              </p>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default MessagesRoute;
